var _path, _path2, _ellipse, _ellipse2, _ellipse3, _ellipse4, _ellipse5, _ellipse6, _ellipse7, _ellipse8, _ellipse9, _ellipse10, _ellipse11, _path3, _ellipse12, _ellipse13, _ellipse14, _ellipse15, _ellipse16, _ellipse17, _ellipse18, _ellipse19, _ellipse20, _ellipse21, _ellipse22;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconTelescope = /*#__PURE__*/React.forwardRef((_ref, ref) => {
  let {
    className,
    height = 61,
    titleId,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 161 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.8691 23C22.0353 23 23.4156 21.6815 23.4156 18.5C23.4156 21.6815 24.7864 23 27.9622 23C24.7864 23 23.4156 24.3567 23.4156 27.5C23.4156 24.3567 22.0353 23 18.8691 23Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M128.996 51C132.162 51 133.543 49.6815 133.543 46.5C133.543 49.6815 134.913 51 138.089 51C134.913 51 133.543 52.3567 133.543 55.5C133.543 52.3567 132.162 51 128.996 51Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 136.04,
    cy: 2.08552,
    rx: 1.60191,
    ry: 1.58552,
    fill: "currentColor"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.412,
    cy: 12.0855,
    rx: 1.60191,
    ry: 1.58552,
    fill: "currentColor"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.6878,
    cy: 5.08552,
    rx: 1.60191,
    ry: 1.58552,
    fill: "currentColor"
  })), _ellipse4 || (_ellipse4 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 159.553,
    cy: 25.0725,
    rx: 0.947469,
    ry: 0.937778,
    fill: "currentColor"
  })), _ellipse5 || (_ellipse5 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 131.688,
    cy: 28.2347,
    rx: 0.947469,
    ry: 0.937778,
    fill: "currentColor"
  })), _ellipse6 || (_ellipse6 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 106.447,
    cy: 41.4378,
    rx: 0.947469,
    ry: 0.937778,
    fill: "currentColor"
  })), _ellipse7 || (_ellipse7 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.4475,
    cy: 33.4378,
    rx: 0.947469,
    ry: 0.937778,
    fill: "currentColor"
  })), _ellipse8 || (_ellipse8 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.44747,
    cy: 12.678,
    rx: 0.947469,
    ry: 0.937778,
    fill: "currentColor"
  })), _ellipse9 || (_ellipse9 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.4025,
    cy: 48.6087,
    rx: 0.947469,
    ry: 0.937778,
    fill: "currentColor"
  })), _ellipse10 || (_ellipse10 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.76011,
    cy: 59.1656,
    rx: 1.60191,
    ry: 1.58552,
    fill: "currentColor"
  })), _ellipse11 || (_ellipse11 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.1019,
    cy: 58.0855,
    rx: 1.60191,
    ry: 1.58552,
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M67.6749 54.9521L77.5187 38.5459M77.5187 38.5459L87.3624 54.9521M77.5187 38.5459V54.9521M60.1806 27.9015L65.2424 25.8365L67.7231 31.9112L62.659 33.9784C62.526 34.0327 62.3836 34.0603 62.2399 34.0595C62.0963 34.0588 61.9542 34.0298 61.8217 33.9741C61.6893 33.9185 61.5691 33.8373 61.468 33.7352C61.367 33.633 61.287 33.512 61.2328 33.379L59.5812 29.3277C59.5269 29.1947 59.4993 29.0523 59.5 28.9087C59.5007 28.765 59.5298 28.6229 59.5854 28.4904C59.6411 28.358 59.7223 28.2378 59.8244 28.1368C59.9265 28.0357 60.0475 27.9558 60.1806 27.9015ZM65.0149 22.3846L76.1537 17.839L81.1128 29.9906L69.974 34.5362C69.841 34.5905 69.6986 34.6181 69.5549 34.6174C69.4113 34.6166 69.2692 34.5876 69.1367 34.532C69.0043 34.4763 68.8841 34.3951 68.783 34.293C68.682 34.1908 68.602 34.0698 68.5478 33.9368L64.4134 23.8109C64.3591 23.6777 64.3316 23.5352 64.3325 23.3914C64.3334 23.2477 64.3626 23.1055 64.4185 22.973C64.4743 22.8406 64.5558 22.7204 64.6581 22.6194C64.7605 22.5185 64.8817 22.4387 65.0149 22.3846ZM93.2074 7.52055C93.1208 7.30824 92.9906 7.11646 92.8252 6.95758C92.6598 6.7987 92.463 6.67625 92.2474 6.59813C92.0318 6.52001 91.8022 6.48796 91.5735 6.50404C91.3447 6.52012 91.1219 6.58398 90.9193 6.69149L76.2259 14.1049C75.8666 14.2955 75.5908 14.6127 75.4522 14.9951C75.3135 15.3775 75.3219 15.7977 75.4756 16.1743L81.7931 31.6531C81.9467 32.0297 82.2348 32.3359 82.6014 32.5121C82.968 32.6883 83.387 32.7221 83.7771 32.6068L99.4637 27.6215C99.6829 27.5565 99.8861 27.4463 100.06 27.2981C100.234 27.1499 100.375 26.9669 100.474 26.7609C100.574 26.5548 100.628 26.3303 100.636 26.1018C100.643 25.8733 100.602 25.6458 100.516 25.434L93.2074 7.52055Z",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
});
export const Icon = /*#__PURE__*/React.forwardRef((_ref2, ref) => {
  let {
    className: propClassName = "",
    fill = "none",
    stroke = "currentColor",
    weight = "normal",
    height = 61,
    titleId,
    title,
    ...props
  } = _ref2;
  const className = "vector-effect-non-scaling-stroke " + propClassName;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 161 61",
    fill: fill,
    xmlns: "http://www.w3.org/2000/svg",
    className: className,
    height: height,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M18.8691 23C22.0353 23 23.4156 21.6815 23.4156 18.5C23.4156 21.6815 24.7864 23 27.9622 23C24.7864 23 23.4156 24.3567 23.4156 27.5C23.4156 24.3567 22.0353 23 18.8691 23Z",
    fill: "currentColor",
    stroke: stroke,
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.996 51C132.162 51 133.543 49.6815 133.543 46.5C133.543 49.6815 134.913 51 138.089 51C134.913 51 133.543 52.3567 133.543 55.5C133.543 52.3567 132.162 51 128.996 51Z",
    fill: "currentColor",
    stroke: stroke,
    strokeWidth: 2.5,
    strokeLinejoin: "round"
  }), _ellipse12 || (_ellipse12 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 136.04,
    cy: 2.08552,
    rx: 1.60191,
    ry: 1.58552,
    fill: "currentColor"
  })), _ellipse13 || (_ellipse13 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 120.412,
    cy: 12.0855,
    rx: 1.60191,
    ry: 1.58552,
    fill: "currentColor"
  })), _ellipse14 || (_ellipse14 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.6878,
    cy: 5.08552,
    rx: 1.60191,
    ry: 1.58552,
    fill: "currentColor"
  })), _ellipse15 || (_ellipse15 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 159.553,
    cy: 25.0725,
    rx: 0.947469,
    ry: 0.937778,
    fill: "currentColor"
  })), _ellipse16 || (_ellipse16 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 131.688,
    cy: 28.2347,
    rx: 0.947469,
    ry: 0.937778,
    fill: "currentColor"
  })), _ellipse17 || (_ellipse17 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 106.447,
    cy: 41.4378,
    rx: 0.947469,
    ry: 0.937778,
    fill: "currentColor"
  })), _ellipse18 || (_ellipse18 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.4475,
    cy: 33.4378,
    rx: 0.947469,
    ry: 0.937778,
    fill: "currentColor"
  })), _ellipse19 || (_ellipse19 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 1.44747,
    cy: 12.678,
    rx: 0.947469,
    ry: 0.937778,
    fill: "currentColor"
  })), _ellipse20 || (_ellipse20 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 22.4025,
    cy: 48.6087,
    rx: 0.947469,
    ry: 0.937778,
    fill: "currentColor"
  })), _ellipse21 || (_ellipse21 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 2.76011,
    cy: 59.1656,
    rx: 1.60191,
    ry: 1.58552,
    fill: "currentColor"
  })), _ellipse22 || (_ellipse22 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 48.1019,
    cy: 58.0855,
    rx: 1.60191,
    ry: 1.58552,
    fill: "currentColor"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M67.6749 54.9521L77.5187 38.5459M77.5187 38.5459L87.3624 54.9521M77.5187 38.5459V54.9521M60.1806 27.9015L65.2424 25.8365L67.7231 31.9112L62.659 33.9784C62.526 34.0327 62.3836 34.0603 62.2399 34.0595C62.0963 34.0588 61.9542 34.0298 61.8217 33.9741C61.6893 33.9185 61.5691 33.8373 61.468 33.7352C61.367 33.633 61.287 33.512 61.2328 33.379L59.5812 29.3277C59.5269 29.1947 59.4993 29.0523 59.5 28.9087C59.5007 28.765 59.5298 28.6229 59.5854 28.4904C59.6411 28.358 59.7223 28.2378 59.8244 28.1368C59.9265 28.0357 60.0475 27.9558 60.1806 27.9015ZM65.0149 22.3846L76.1537 17.839L81.1128 29.9906L69.974 34.5362C69.841 34.5905 69.6986 34.6181 69.5549 34.6174C69.4113 34.6166 69.2692 34.5876 69.1367 34.532C69.0043 34.4763 68.8841 34.3951 68.783 34.293C68.682 34.1908 68.602 34.0698 68.5478 33.9368L64.4134 23.8109C64.3591 23.6777 64.3316 23.5352 64.3325 23.3914C64.3334 23.2477 64.3626 23.1055 64.4185 22.973C64.4743 22.8406 64.5558 22.7204 64.6581 22.6194C64.7605 22.5185 64.8817 22.4387 65.0149 22.3846ZM93.2074 7.52055C93.1208 7.30824 92.9906 7.11646 92.8252 6.95758C92.6598 6.7987 92.463 6.67625 92.2474 6.59813C92.0318 6.52001 91.8022 6.48796 91.5735 6.50404C91.3447 6.52012 91.1219 6.58398 90.9193 6.69149L76.2259 14.1049C75.8666 14.2955 75.5908 14.6127 75.4522 14.9951C75.3135 15.3775 75.3219 15.7977 75.4756 16.1743L81.7931 31.6531C81.9467 32.0297 82.2348 32.3359 82.6014 32.5121C82.968 32.6883 83.387 32.7221 83.7771 32.6068L99.4637 27.6215C99.6829 27.5565 99.8861 27.4463 100.06 27.2981C100.234 27.1499 100.375 26.9669 100.474 26.7609C100.574 26.5548 100.628 26.3303 100.636 26.1018C100.643 25.8733 100.602 25.6458 100.516 25.434L93.2074 7.52055Z",
    stroke: stroke,
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
});
export default SvgIconTelescope;
export const raw = __webpack_public_path__ + "static/media/icon-telescope.5b686bc1b0b1e59e31819cea5905e3f3.svg";